import 'styled-components';
import { useCallback, useLayoutEffect, useMemo } from 'react';
import { usePageTitle } from '@/hooks/usePageTitle.ts';
import { useAvailableLanguages } from '@/hooks/useAvailableLanguages.ts';
import { Row, Text } from '@keyslabor/shared/ui';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { Language } from '@/api/types';
import { useApplyJobDetails } from '@/api/services.ts';
import LayoutContainer from '@/components/LayoutPageMobile/LayoutContainer.tsx';
import { routes } from '@/constants.ts';
import { useAppLanguage } from '@/hooks/useAppLanguage.ts';
import { css } from 'styled-components';
import { LanguageOptionsList } from '@/components/LanguageOptionsList';
import { getAutoSelectLanguage, normalizeLanguages } from '@/lib/language';

function Welcome() {
  const [language, setLanguage] = useAppLanguage();
  const params = useParams<{property_id: string}>();
  const { data: jobDetails } = useApplyJobDetails(params.property_id || '', language);

  usePageTitle(jobDetails?.client_name, 'apply');

  const availableLanguages = useAvailableLanguages(jobDetails?.positions);
  const normalizedLanguages = useMemo(
    () => normalizeLanguages(availableLanguages),
    [availableLanguages]
  );

  const navigate = useNavigate();

  const handleNext = useCallback(
    (language: Language) => {
      setLanguage(language);
      navigate(generatePath(routes.applyForm, {
        property_id: params.property_id || '',
      }));
    },
    [navigate, params.property_id, setLanguage]
  );

  useLayoutEffect(() => {
    const autoSelectLanguage = getAutoSelectLanguage({
      availableLanguages: normalizedLanguages,
    });
    if (autoSelectLanguage) {
      handleNext(autoSelectLanguage);
    }
  }, [normalizedLanguages, handleNext]);

  return (
    <LayoutContainer
      pb="20px"
      css={css`
        & {
          min-height: 100vh;
          min-height: 100dvh;
            background-image: url('/lang_bg.png');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }
      `}
    >
      <Row flexCenter>
        <Text
          fontWeight="800"
          fontSize="18px"
          maxWidth="220px"
          upper
          center
          mt="40px"
        >
          Please select
          interview language
        </Text>

        <LanguageOptionsList languages={normalizedLanguages} onSelect={handleNext} />
      </Row>
    </LayoutContainer>
  );
}

export default Welcome;
